import React, { useEffect, useState } from "react";
import {
  Badge,
  Box,
  IconButton,
  Menu,
  Typography,
} from "@mui/material";
import { ReactComponent as SearchIcon } from "../../assets/svg/search-icon.svg";
import { ReactComponent as NotificationIcon } from "../../assets/svg/notification-bell.svg";
import MainLogo from "../../assets/images/mainlogoNew.png";
import { ReactComponent as PersonIcon } from "../../assets/svg/person-icon.svg";
import { ReactComponent as DownArrowSvg } from "../../assets/svg/down-arrow-icon.svg";
import { ReactComponent as HamburgerIcon } from "../../assets/svg/hamburger-menu-icon.svg";
import { ReactComponent as LockIcon } from "../../assets/svg/lock-icon.svg";
import { ReactComponent as SettingIcon } from "../../assets/svg/setting-icon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/svg/logout-icon.svg";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GetNotificationsDataService, GetAgentNotificationsDataService } from "../../services/CommonService";
import { useDispatch, useSelector } from "react-redux";
import { userDashboardSelector } from "../../redux/userDashboard";
import Loader from "../../components/loader/Loader";
function Navbar({
  visible,
  headingTitle,
  headingSubtitle,
  handleDrawerToggle,
  isWithoutSideBar,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { notificationsDataListing } = useSelector(userDashboardSelector);
  const { agentNotificationsDataListing } = useSelector(userDashboardSelector);
  const [loading, setLoading] = useState(false);
  const [notificationLength, setNotificationLength] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userDetails, setUserDetails] = useState({});
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    if (localStorage?.getItem("user")) {
      const user = JSON.parse(localStorage?.getItem("user") || "{}");
      setUserDetails(user);
      getNotificationsData();
    }
    if (localStorage?.getItem("agent_user")) {
      const user = JSON.parse(localStorage?.getItem("agent_user") || "{}");
      setUserDetails(user);
      getAgentNotificationsData();
    }

  }, []);
  const handleLogout = () => {
    localStorage?.clear();
    navigate("/");
  };
  // setNotificationLength(notificationsDataListing.items.length)
  if (!visible) {
    return null;
  }
  const getNotificationsData = () => {
    try {
      const response = dispatch(GetNotificationsDataService());
    } catch (error) {
      console.error("API request error:", error);
    }
  };
  const getAgentNotificationsData = () => {
    try {
      const response = dispatch(GetAgentNotificationsDataService());
    } catch (error) {
      console.error("API request error:", error);
    }
  };
  const navigateToNotifications = () => {
    handleClose();

    if (localStorage?.getItem("user")) {
      navigate("/user-settings?tab=notifications");
      return;
    }

    navigate("/agent-settings?tab=notifications");
  };
  const navigateToAgentSettings = () => {
    navigate("/settings");
  }
  const navigateToUserSettings = () => {
    navigate("/user-settings");
  }
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: { xs: "8px 12px", sm: "8px 16px", md: "1px 20px 2px 10px" },
          borderBottom: "1px solid #7c7c7c4f",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: "8px", md: "0" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: { xs: "100%", md: "auto" },
            marginBottom: { xs: "0.5rem", md: "0" },
          }}
        >
          <IconButton
            sx={{
              backgroundColor: "#ffffff",
              width: { xs: "36px", sm: "40px" },
              height: { xs: "36px", sm: "40px" },
              borderRadius: "10px",
              display: { xs: "flex", md: "none" },
            }}
            onClick={handleDrawerToggle}
            className="dashboard-notification-icon"
          >
            <HamburgerIcon className="dashboard-nav-hamburger-icon" />
          </IconButton>
          {isWithoutSideBar && (
            <Box sx={{ display: { xs: "none", md: "block" }, mr: 2 }}>
              <Link to="/">
                <img src={MainLogo} alt="i-moz-logo" className="logo-img" />
              </Link>
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: "8px", sm: "12px" },
              flex: 1,
              justifyContent: "flex-start",
              marginLeft: { xs: "8px", md: "0" },
            }}
          >
            <Typography
              variant="lSize"
              component="div"
              className="purple-color font-w-600"
              sx={{
                fontSize: { xs: "16px", sm: "20px", md: "24px", lg: "32px" },
                lineHeight: { xs: "20px", sm: "24px", md: "28px", lg: "32px" },
              }}
            >
              {headingTitle}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: "8px", sm: "12px", md: "3px" },
            justifyContent: "flex-end",
            width: { xs: "100%", md: "auto" },
          }}
        >
          {localStorage?.getItem("user") ?
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                width: { xs: "40px", sm: "50px", md: "60px" },
                height: { xs: "40px", sm: "50px", md: "60px" },
                borderRadius: "10px",
              }}
              className="dashboard-notification-icon"
              onClick={navigateToNotifications}
            >
              <Badge color="secondary" badgeContent={
                notificationsDataListing.items.length > 0 ? notificationsDataListing.items.length : null}
                max={notificationsDataListing.items.length}>
                <NotificationIcon sx={{ width: { xs: 18, sm: 22, md: 28 }, height: { xs: 18, sm: 22, md: 28 } }} />
              </Badge>
            </IconButton>
            :
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                width: { xs: "40px", sm: "50px", md: "60px" },
                height: { xs: "40px", sm: "50px", md: "60px" },
                borderRadius: "10px",
              }}
              className="dashboard-notification-icon"
              onClick={navigateToNotifications}
            >
              <Badge color="secondary" badgeContent={
                agentNotificationsDataListing.items.length > 0 ? agentNotificationsDataListing.items.length : null}
                max={agentNotificationsDataListing.items.length}>
                <NotificationIcon sx={{ width: { xs: 18, sm: 22, md: 28 }, height: { xs: 18, sm: 22, md: 28 } }} />
              </Badge>
            </IconButton>
          }

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: "4px", sm: "6px", md: "8px" },
              cursor: "pointer",
            }}
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <Box
              sx={{
                backgroundColor: "#ffffff",
                width: { xs: "40px", sm: "50px", md: "60px" },
                height: { xs: "40px", sm: "50px", md: "60px" },
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <PersonIcon sx={{ width: { xs: 18, sm: 22, md: 28 }, height: { xs: 18, sm: 22, md: 28 } }} />
            </Box>
            <DownArrowSvg className="filter-options-down-arrow" sx={{ width: { xs: 10, sm: 12, md: 16 }, height: { xs: 10, sm: 12, md: 16 } }} />
          </Box>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            sx={{ borderRadius: "16px" }}
            className="user-navbar-account-menu"
          >
            <Box className="user-profile-container">
              <Box
                sx={{
                  backgroundColor: "#ffffff",
                  width: "40px",
                  height: "40px",
                  borderRadius: "14px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <PersonIcon className="user-profile-icon" />
              </Box>
              <Box sx={{ width: "120px", maxWidth: "120px" }}>
                <Typography
                  component="div"
                  variant="xxxsSize"
                  className="font-w-600 white-color"
                  sx={{
                    marginBottom: "3px",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {userDetails?.first_name}
                </Typography>
                <Typography
                  component="div"
                  variant="xxxsSize"
                  className="font-w-600 white-color"
                  sx={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {userDetails?.email}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "16px 24px",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              {localStorage?.getItem("user") ?
                <>
                  <Box
                    onClick={() => {
                      handleClose();
                      navigate("/user-settings");
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "pointer",
                    }}
                  >
                    <SettingIcon className="user-menu-items-icon" />
                    <Typography
                      component="div"
                      variant="xxxsSize"
                      className="font-w-600 blue-color"
                    >
                      {t("Profile.Profile Settings")}
                    </Typography>
                  </Box>
                  <Box
                    onClick={() => {
                      handleClose();
                      navigate("/user-settings");
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "pointer",
                    }}
                  >
                    <LockIcon className="user-menu-items-icon" />
                    <Typography
                      component="div"
                      variant="xxxsSize"
                      className="font-w-600 blue-color"
                    >
                      {t("Profile.Change Password")}
                    </Typography>
                  </Box>
                </>
                :
                <>
                  <Box
                    onClick={() => {
                      handleClose();
                      navigate("/agent-settings");
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "pointer",
                    }}
                  >
                    <SettingIcon className="user-menu-items-icon" />
                    <Typography
                      component="div"
                      variant="xxxsSize"
                      className="font-w-600 blue-color"
                    >
                      {t("Profile.Profile Settings")}
                    </Typography>
                  </Box>
                  <Box
                    onClick={() => {
                      handleClose();
                      navigate("/agent-settings");
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "pointer",
                    }}
                  >
                    <LockIcon className="user-menu-items-icon" />
                    <Typography
                      component="div"
                      variant="xxxsSize"
                      className="font-w-600 blue-color"
                    >
                      {t("Profile.Change Password")}
                    </Typography>
                  </Box>
                </>}

              <Box
                onClick={() => handleLogout()}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                }}
              >
                <LogoutIcon className="user-menu-items-icon" />
                <Typography
                  component="div"
                  variant="xxxsSize"
                  className="font-w-600 blue-color"
                >
                  {t("Profile.Logout")}
                </Typography>
              </Box>
            </Box>
          </Menu>
        </Box>
      </Box>
    </>
  );
}

export default Navbar;

Navbar.defaultProps = {
  visible: true,
  rightComp: null,
};
